import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { NumberOfGuests } from 'components/NumberOfGuests/NumberOfGuests';
import { useCallback, useMemo } from 'react';
import { styles } from './BaseNumberOfGuestsModal.css';

export const BaseNumberOfGuestsModal: React.FC = () => {
	const { setActiveFilter, selection } = useFiltersContext();
	const { setShowFiltersModal, setNumberOfGuestsSelection, numberOfGuestsSelection } = useFiltersModalContext();

	const currentSelection = useMemo(() => {
		return {
			adults: parseInt(selection?.adults[0] || numberOfGuestsSelection.adults.toString()),
			children: parseInt(selection?.children[0] || numberOfGuestsSelection.children.toString()),
		};
	}, [selection, numberOfGuestsSelection.adults, numberOfGuestsSelection.children]);

	const onCloseClickHandler = useCallback(() => {
		setShowFiltersModal(false);
		setActiveFilter(null);
	}, [setShowFiltersModal, setActiveFilter]);

	return (
		<NumberOfGuests
			testId="number-of-guests-modal"
			selection={currentSelection}
			onChange={setNumberOfGuestsSelection}
			rootClass={styles.root}
			onCloseClick={onCloseClickHandler}
			onBackdropClick={onCloseClickHandler}
			disableScrolling={false}
			showHeader={false}
		/>
	);
};
